import { EVENT_KEY, TRACKING_ACTION, TRACKING_INTERACTION } from 'src/config/tracking/index.js'
import trackingUtils from 'src/config/services/countlyTracking/utils.js'

const calendarTracking = {
  trackCalendar (entity = 'calendarEvent', result = 'SUCCESS', failedReason = null) {
    const interaction = {
      jumpToToday: () => trackingUtils.track(EVENT_KEY.CALENDAR.INTERACTION, { interaction: TRACKING_INTERACTION.CLICK_JUMP_TO_TODAY }),
      selectViewBy: (viewType) => {
        const interaction = {
          day: TRACKING_INTERACTION.SELECT_VIEW_BY_DAY,
          week: TRACKING_INTERACTION.SELECT_VIEW_BY_WEEK,
          month: TRACKING_INTERACTION.SELECT_VIEW_BY_MONTH,
          list: TRACKING_INTERACTION.SELECT_VIEW_BY_LIST
        }
        return trackingUtils.track(EVENT_KEY.CALENDAR.INTERACTION, { interaction: interaction[viewType] })
      },
      clickEvent: () => trackingUtils.track(EVENT_KEY.CALENDAR.INTERACTION, { interaction: TRACKING_INTERACTION.CLICK_EVENT }),
      contactCreator: () => trackingUtils.track(EVENT_KEY.CALENDAR.INTERACTION, { interaction: TRACKING_INTERACTION.CLICK_CONTACT_CREATOR })
    }
    const start = {
      create: () => trackingUtils.track(EVENT_KEY.CALENDAR.START, { action: TRACKING_ACTION.CREATE, entity }),
      edit: () => trackingUtils.track(EVENT_KEY.CALENDAR.START, { action: TRACKING_ACTION.EDIT, entity }),
      delete: () => trackingUtils.track(EVENT_KEY.CALENDAR.START, { action: TRACKING_ACTION.DELETE, entity })
    }
    const end = {
      submit: ({ isEditMode = false, trackGlobal = null }) => trackingUtils.trackWithResult(EVENT_KEY.CALENDAR.END, { action: isEditMode ? TRACKING_ACTION.EDIT : TRACKING_ACTION.CREATE, entity, result, failedReason, trackGlobal }),
      delete: ({ trackGlobal = null }) => trackingUtils.trackWithResult(EVENT_KEY.CALENDAR.END, { action: TRACKING_ACTION.DELETE, entity, result, failedReason, trackGlobal })
    }
    return {
      interaction,
      start,
      end
    }
  }
}

export default calendarTracking
